import React from 'react';
export const MalnutritionSection = () => {
  return <section id="malnutrition" className="w-full py-12 bg-amber-50" data-id="element-160">
      <div className="container mx-auto px-4" data-id="element-161">
        <h2 className="text-2xl md:text-3xl font-bold text-green-900 mb-6 text-center" data-id="element-162">
          Is Your Dog Showing Signs of Ancestral Malnutrition?
        </h2>
        <div className="flex flex-col md:flex-row gap-8 mb-8" data-id="element-163">
          <div className="w-full md:w-1/2" data-id="element-164">
            <p className="text-green-900/80 mb-4" data-id="element-165">
              Modern kibble has created an epidemic of "well-fed but
              malnourished" dogs. Even premium brands lack the organ meats,
              diverse proteins, and soil-based probiotics dogs evolved to need.
            </p>
            <div className="bg-green-900/10 p-6 rounded-lg shadow-md mb-6" data-id="element-166">
              <h3 className="text-xl font-bold text-green-900 mb-4" data-id="element-167">
                The Result?
              </h3>
              <ul className="text-green-900/80 space-y-2" data-id="element-168">
                <li data-id="element-169">• Chronic inflammation starting in the gut</li>
                <li data-id="element-170">• Weakened immune systems</li>
                <li data-id="element-171">• Premature aging</li>
                <li data-id="element-172">• Constant health issues</li>
              </ul>
            </div>
            <p className="text-green-900/80 mb-4" data-id="element-173">
              The Solution? The Daily Foundation Chew™ doesn't just add
              probiotics – it restores the complete ancestral nutrition profile
              your dog's body recognizes and craves.
            </p>
            <div className="bg-green-900/10 p-6 rounded-lg shadow-md mb-6" data-id="element-174">
              <h3 className="text-xl font-bold text-green-900 mb-4" data-id="element-175">
                One Daily Chew Provides:
              </h3>
              <ul className="text-green-900/80 space-y-2" data-id="element-176">
                <li data-id="element-177">• 750mg freeze-dried organ meats (liver, heart, kidney)</li>
                <li data-id="element-178">• 1 Billion CFU resilient soil-based probiotics</li>
                <li data-id="element-179">• 500mg New Zealand green-lipped mussel</li>
                <li data-id="element-180">• 100mg CurcuVET® (bioavailable curcumin)</li>
                <li data-id="element-181">• 50mg organic spirulina</li>
              </ul>
            </div>
            <p className="text-green-900/80 mb-6" data-id="element-182">
              This isn't random – it's precisely what your dog's ancestors
              consumed naturally but modern diets have eliminated.
            </p>
            <div className="flex justify-center" data-id="element-183">
              <a href="#cta" className="bg-yellow-700 hover:bg-yellow-800 text-amber-50 font-bold py-3 px-8 rounded-full text-lg shadow-md transition duration-300 inline-block" data-id="element-184">
                SEE FULL INGREDIENTS
              </a>
            </div>
          </div>
          <div className="w-full md:w-1/2 flex flex-col justify-center" data-id="element-185">
            
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/25FyRdBLFzRtEM8ggqzinn/ChatGPT_Image_20_de_jul._de_2025%2C_15_36_12.png" alt="Golden retriever portrait with DNA helix and nutritional elements visualization" className="rounded-lg w-full mb-6" data-id="element-186" />
            <p className="text-green-900 text-center font-bold" data-id="element-187">
              Is your dog showing signs of seasonal allergies, yeast, itchiness
              or poor digestion?
            </p>
          </div>
        </div>
      </div>
    </section>;
};